import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex w-full justify-between pb-5" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h6", { class: "font-semibold text-xl text-black" }, "Informasi Pengembalian Paket"),
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey" }, "Berikut informasi pengembalian paket dari kurir")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "background-grey-lighten-5 p-3 mb-4"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-sm mb-2" }, "Pengajuan oleh :", -1)
const _hoisted_5 = { class: "flex gap-2 items-center" }
const _hoisted_6 = { class: "font-semibold cursor-pointer break-words text-xl" }
const _hoisted_7 = {
  key: 1,
  class: "background-grey-lighten-5 p-3 mb-4"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-sm mb-2" }, "Alasan pengembalian :", -1)
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-white" }, "Konfirmasi Pengembalian Paket", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")
  const _component_Lightgallery = _resolveComponent("Lightgallery")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_DialogConfirm = _resolveComponent("DialogConfirm")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.isShowDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowDialog = $event)),
      dismissableMask: true,
      modal: true,
      style: { width: '80vw' },
      onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideDialog())),
      class: "dialog-confirm"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode("i", {
            class: "pi pi-times text-black cursor-pointer text-xl",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideDialog()))
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_Button, {
            class: "p-button-sm btn-secondary",
            label: "Tolak Pengembalian Paket",
            disabled: _ctx.isLoading,
            onClick: _ctx.onDecline
          }, null, 8, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            class: "p-button-sm btn-primary justify-center",
            disabled: _ctx.isLoading,
            onClick: _ctx.onConfirm
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("section", null, [
          (_ctx.dataCourier && !_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4,
                _createVNode("div", _hoisted_5, [
                  (_ctx.dataCourier.Picture)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: `${_ctx.API_BASE}${_ctx.dataCourier.Picture}`,
                        class: "rounded-full object-cover w-20 h-20"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_Avatar, {
                        key: 1,
                        label: _ctx.dataCourier.Name?.charAt(0),
                        shape: "circle",
                        size: "large"
                      }, null, 8, ["label"])),
                  _createVNode("p", _hoisted_6, _toDisplayString(_ctx.dataCourier.Name), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.dataReturnRequest && !_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("p", _hoisted_9, _toDisplayString(_ctx.dataReturnRequest.Note), 1),
                _createVNode(_component_Lightgallery, {
                  images: _ctx.dataReturnRequest.Documents,
                  class: "grid grid-cols-6 gap-4",
                  id: "id-list-documents"
                }, {
                  content: _withCtx(({ image }) => [
                    _createVNode("img", {
                      src: image.src,
                      class: "w-full",
                      alt: image.alt,
                      style: {"object-fit":"contain"}
                    }, null, 8, ["src", "alt"])
                  ]),
                  _: 1
                }, 8, ["images"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DialogConfirm, { ref: "refDialogConfirm" }, null, 512)
  ]))
}